import { queryDuck } from '@/ducks';

import { srpActiveInteractionDuck } from '@/ducks/srp';

export const categoryOptions = [
    {
        label: 'All Results',
        icon: 'allResults',
        filterName: 'allResults',
        value: 'allResults',
    },
    {
        label: 'Best Deals',
        icon: 'goodDeals',
        filterName: 'dealType',
        value: {
            dealType: ['goodprice', 'greatprice'],
        },
    },
    {
        label: 'Buy Online',
        icon: 'buyOnline',
        filterName: 'homeServices',
        value: {
            homeServices: ['BUY_ONLINE'],
        },
    },
    {
        label: 'For Sale By Owner',
        icon: 'ownerSale',
        filterName: 'sellerType',
        value: {
            sellerType: ['p'],
        },
    },
    {
        label: 'Certified Used',
        icon: 'certifiedUsed',
        filterName: 'listingType',
        value: {
            listingType: ['CERTIFIED', '3P_CERT'],
        },
    },
];

export function removeCategory({ activeCategory, filterValue, dispatch }) {
    if (activeCategory !== 'All Results') {
        const activeCategoryObject = categoryOptions.find((option) => option.label === activeCategory);
        const activeCategoryValues = !!activeCategoryObject && Object.values(activeCategoryObject?.value)[0];

        if (activeCategoryValues.includes(filterValue)) {
            dispatch(srpActiveInteractionDuck.creators.setKeys({
                activeCategory: 'All Results',
            }));
            dispatch(queryDuck.creators.setKeys({
                categorySearch: 'allResults',
            }));
        }
    }
}

export const getCategoryFromQueryParams = ({ filtersValues, query }) => {
    const { categorySearch = '' } = query;
    const category = categoryOptions.find((option) => option.filterName === categorySearch);

    const filtersMatchQueryParam = Object.keys(filtersValues).includes(category?.filterName);

    if (category && filtersMatchQueryParam) {
        return category.label;
    }

    return 'All Results';
};

export default {
    categoryOptions,
    getCategoryFromQueryParams,
    removeCategory,
};
